(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/category-tickets-wheel.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/category-tickets-wheel.js');
"use strict";


const CategoryTicketsWheel = _ref => {
  let category = _ref.category;
  const CategoryTitle = svs.eInstant.shared.components.CategoryTitle;
  const TicketsWheel = svs.eInstant.components.TicketsWheel;
  return React.createElement("div", {
    className: "lobby-categories-mobile"
  }, React.createElement(CategoryTitle, {
    category: category,
    className: "margin-left-1"
  }), React.createElement(TicketsWheel, {
    accessibleText: category.title || 'Välj spel',
    games: category.games,
    numberedList: category.numberedList
  }));
};
setGlobal('svs.eInstant.shared.components.CategoryTicketsWheel', CategoryTicketsWheel);

 })(window);